import './App.scss';
import { FC, useEffect } from 'react';
import AppLayout from './layout/AppLayout';
import configureStore from '../src/redux/core/store.config';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MsalProvider } from "@azure/msal-react";
import { Configuration, EndSessionRequest, PublicClientApplication } from "@azure/msal-browser";

const configuration: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "8e602b40-1fc0-4395-a10e-e90fa1588f3d",
    redirectUri: "/",
    authority: "https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    tokenRenewalOffsetSeconds: 60 * 60 // Set token expiry to 60 minutes
  }
};

// Logic to get a new ID token every 58 minutes
const refreshTokenInterval = 58 * 60 * 1000; // 58 minutes in milliseconds

const startTokenRefresh = () => {
  setInterval(async () => {
    try {
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        const silentRequest = {
          account: accounts[0],
          // 'email' scope ensures the backend sees an email-like claim on the token.
          scopes: ["openid", "profile", "email"]
        };
        const response = await instance.acquireTokenSilent(silentRequest);
        console.log("ID Token refreshed successfully:", response.idToken);
      }
    } catch (error) {
      console.error("Error refreshing ID token:", error);
    }
  }, refreshTokenInterval);
};

const instance = new PublicClientApplication(configuration);
instance.initialize();

startTokenRefresh();

const useAutoLogout = (logoutAfterMinutes = 30) => {
  useEffect(() => {
    let timeoutId: any;

    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        // Define the logout request
        const logoutRequest: EndSessionRequest = {
          postLogoutRedirectUri: '/',
        };

        // Perform logout with redirect
        instance.logoutRedirect(logoutRequest);
      }, logoutAfterMinutes * 60 * 1000); // Convert minutes to milliseconds
    };

    // Events to reset the timer
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.onclick = resetTimer;

    // Set the initial timer
    resetTimer();

    return () => {
      clearTimeout(timeoutId);
    };
  }, [logoutAfterMinutes]);
};

const App: FC = () => {
  useAutoLogout(30);
  return (
    <MsalProvider instance={instance}>
      <Provider store={configureStore()}>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </Provider>
    </MsalProvider>
  );
};

export default App;
